import './enhanced-text-area.scss'

import { faEraser } from '@fortawesome/free-solid-svg-icons';
import { FormApi } from 'final-form';
import { set } from 'lodash'
import { defineComponent } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const EnhancedTextArea = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['placeHolder', 'scanEnabled', 'defaultValue', 'form', 'name', 'autoUpdate', 'readOnly'],
    template: require('./enhanced-text-area.html'),
    data() {
        return {
            clearIcon: faEraser,
            value: "",
        }
    },
    mounted() {
        this.setFieldValue(this.defaultValue);
        this.$on('field-value-changed', (message) =>
            this.$parent?.$emit('field-value-changed', message)
        )
    },
    methods: {
        eraseInput() {
            this.setFieldValue("");
        },
        setFieldValue(value: string) {
            set(this.form.getState().values, this.name, value)
            this.form.mutators.setFieldTouched(this.name);
        },
    },
})
